<template>
  <v-container>
    <div class="create_user">
        <h1>ユーザ新規作成</h1>
        <div class="forms">       
            <div class="input_form">
                <p>ユーザーID</p>
                <input type="text" placeholder="ユーザーID" class="form-control" v-model="user.userId"/>
            </div>
            <div class="input_form">
                <p>パスワード</p>
                <input type="text" placeholder="パスワード" class="form-control" v-model="user.password"/>
            </div>
            <div class="input_form">
                <p>サブドメイン</p>
                <input type="text" placeholder="サブドメイン" class="form-control" v-model="user.subdomain"/>
            </div>
            <div class="input_form">
                <p>顧客No</p>
                <input type="text" placeholder="ユーザー名" class="form-control" v-model="user.clientId"/>
            </div>
            <div class="input_form">
                <p>契約者名</p>
                <input type="text" placeholder="ユーザー名" class="form-control" v-model="user.company"/>
            </div>
            <div class="input_form">
                <p>登録名</p>
                <input type="text" placeholder="ユーザー名" class="form-control" v-model="user.name"/>
            </div>
            <div class="input_form">
                <p>ルーム数上限</p>
                <input type="number" class="form-control" v-model="user.roomTotal"/>
            </div>
            <div class="input_form">
                <p>保存ルーム数</p>
                <input type="number" class="form-control" v-model="user.roomcount"/>
            </div>
            <div class="input_form">
                <p>ワンタイムルーム時間（契約）</p>
                <input type="number" class="form-control" v-model="user.randomroomcount"/>
            </div>
            <div class="input_form">
                <p>ワンタイムルーム時間（残量）</p>
                <input type="number" class="form-control" v-model="user.randomroomRemain"/>
            </div>
            <div class="input_form">
                <p>ワンタイムルームパスワード</p>
                <input type="number" class="form-control" v-model="user.randomroomPassword"/>
            </div>
            <div class="input_form">
                <v-select
                :items="plans"
                label="契約プラン"
                v-model="user.plan"
                ></v-select>
            </div>
            <div class="buttons">
                <button type="button" class="btn btn-primary" @click="createUser" value="作成">作成</button>
                <button type="button" class="btn btn-secondary" @click="$router.push('/admintop');" value="キャンセル">キャンセル</button>
            </div>
        </div>
    </div>
    <modal :name="modalName" :draggable="true" :resizable="true">
        <div class="modal-header">
            エラー
        </div>
        <div class="modal-body">
        <p>{{ msg }}</p>
        <div class="buttons">
            <button type="button" class="btn btn-secondary" @click="$modal.hide(modalName)">閉じる</button>
        </div>
    </div>  
    </modal>
  </v-container>
</template>
<script>
    export default {
        data() {
            return {
                user: {},
                modalName: 'error_modal',
                msg: '',
                plans: [
                    "BASIC",
                    "PLEMIUM",
                    "PRO"
                ],
            }
        },
        methods: {
            createUser() {
                if (this.user.userId == '' || this.user.name == '' || this.user.password == '' || this.user.subdomain == '' )
                {
                    this.msg = "すべての項目を入力してください。";
                    this.$modal.show(this.modalName);

                    return;
                }

                if (this.user.randomroomcount < 0)
                {
                    this.msg = "ワンタイムルーム時間が不正です。";
                    this.$modal.show(this.modalName);

                    return;
                }

                this.user.createdAt = new Date().getTime();

                this.$axios.post('/createUser/user/' + JSON.stringify(this.user))
                    .then(res => {
                        // メッセージがある場合は表示のみ行う
                        if (res.data.msg) {
                            this.msg = res.data.msg;
                            this.$modal.show(this.modalName);
                            return;
                        }
                        if (res.status === 200) {
                            this.$router.push('/admintop');
                        }
                    })
                    .catch((err) => {
                        console.log('エラー', err)
                    });
            },
            initUser() {
                this.user = this.adjustUser({role: 2, parentId: this.$store.state.user.id});
            }
        },
        created: function() {
            this.existUser();
            this.initUser();
        }
    }
</script>

<style>
    .create_user {
        margin-top: 100px;
    }
    
    .create_user h1 {
        font-size: 30px;
        text-align: center;
        margin-bottom: 30px;
    }
    
    .create_user .forms {
        max-width: 500px;
        margin: auto;
    }
    
    .create_user .input_form {
        margin-bottom: 30px;
    }
    
    .create_user button {
        color: white;
        margin-right: 10px;
    }
    
    .create_user .buttons {
        text-align: right;
    }

    .modal-body button {
        color: white;
        margin-right: 10px;
    }
    
    .modal-body .buttons {
        text-align: right;
    }
</style>